import { StatusOptions } from "./FilterEnums";
import { LegacyCode } from "./profile";

export interface IApiServiceResponse {
  success: boolean;
  statusCode: number;
  responseBody: any;
  errorMessage: string | null;
}

export interface TripRequestBody {
  legacyCodes: LegacyCode[];
  milestoneValue?: string[];
  approval?: string[];
  dateType?: number;
  dateFrom?: string | null;
  dateTo?: string | null;
  kpi?: TripKPI;
  agencyqualification: string | Date | null;
}

export enum TripKPI {
  WithoutPlate = 1,
  ToBeAccepted = 2,
  WaitingForDocumentation = 3,
}

export interface TripResponse {
  tripID: number;
  tmsObjectNumber: string;
  status: StatusOptions;
  approval: string;
  lastUpdate: string;
  expectedDeparture: string;
  expectedArrival: string;
  tractorLicensePlate: string;
  trailerLicensePlate: string;
  loadingLocation: string;
  unloadingLocation: string;
  loadingCity: string;
  unloadingCity: string;
  documentsRequired: number;
  documentsApproved: number;
  tractorPlateUpdatable: boolean;
  trailerPlateUpdatable: boolean;
}

export interface TripCountResponse {
  count: number;
  kpi?: TripKPI;
}

export interface TripDetails {
  tmsObjectNumber: string;
  tmsKey: string;
  firstDriver: string;
  dispatcherName: string;
  dispatcherMail: string;
  dispatcherPhone: string | null;
  weight: number;
  weightUDM: string;
  volume: number | null;
  volumeUDM: string;
  shipUnitCount: number;
  linearMeters: number;
  linearMetersUDM: string;
  expectedDeparture: string;
  expectedArrival: string;
  actualDeparture: string;
  actualArrival: string | null;
  relatedOrders: string[];

  status: StatusOptions;
  totalAmount: number;
  totalAmountCurrency: string;
  tripCreationDate: string;
}
export interface TripAcceptance {
  approvalStatus: string;
  approvalStatusUpdate: string;
  approvalStatusUser: string;
}
export interface LicensePlateResponse {
  licencePlate: string;
  equipmentType: "TRAILER" | "TRUCK";
  isUpdatable: boolean;
}

export interface RelatedActivityNew {
  activityType: string;
  activityRemark: string;
  activityLastUpdate: string;
}

export interface TripStop {
  dateTime: never[];
  tmsLocation: string; // Codice SGA che identifica lo stop
  invPartyName: string; // Involved Party Name dello Stop
  address: string; // Indirizzo dello stop
  expectedDeparture: string | null; // Data attesa di partenza dallo Stop
  expectedArrival: string | null; // Data attesa di arrivo allo Stop
  actualDeparture: string | null; // Data di partenza effettiva dallo Stop
  actualArrival: string | null; // Data di arrivo effettiva allo Stop
  latitude: number; // Latitudine dello stop
  longitude: number; // Longitudine dello stop
  relatedActivities: RelatedActivityNew[]; // Nuovo campo con attività dettagliate
  bookingCode: string | null; // Codice di Booking
  relatedLoads: RelatedLoad[]; // Lista dei carichi associati allo scarico
  mandatory: boolean
}
export interface RelatedLoad {
  tmsLocation: string; // TMSLocation del punto di carico
  involvedPartyName: string; // Nome della parte coinvolta
  TransportOrderTMSKey: string; // Chiave del trasporto associato
  podSectionRequired: boolean; // Indica se la sezione POD è richiesta
  status: "to be evaluated" | "accepted" | "rejected" | "to be uploaded";
}

export interface Note {
  id: number;
  tripId: number;
  remark: string;
  lastUpdate: string;
  invPartyName: string;
  tmsLocation: string; // Nuovo campo per il raggruppamento
}


export interface UpdateLicencePlateRequest {
  tripID: number;
  licensePlate: string;
  equipmentType: "TRAILER" | "TRUCK";
  user: string;
}

export interface UpdateLicencePlateResponse {
  id: number;
  licensePlate: string;
  equipmentType: "TRAILER" | "TRUCK";
  date: string;
  user: string;
  message: string;
  traceabilitySuccess?: boolean;
  isTraceability?: boolean;
  tripsInfo?: Array<{ tmsObjectNumber: string; tripID: number }>;
  lastTraceabilityCheckDate?: string;
  platform?: string;
}

// Richiesta per inviare un documento
export interface SendTripDocumentRequest {
  document: {
    bufferIds: string[];
  };
  fields: TripDocumentField[];
}

// Campo individuale nella richiesta
export interface TripDocumentField {
  value: string | number;
  name: string;
  className: string;
  externalId?: string;
}

// Risposta per l'invio di un documento
export interface SendTripDocumentResponse {
  docNumber: number;
  internalProtocolNumber: string;
  year: number | null;
  protocolNumber: string | null;
  showMessage: boolean;
}


export interface UploadPODRequest {
  Cod_Ordine: string; // TMS Object Number dell'ordine
  Cod_Viaggio: string; // TMS Object Number della disposizione
  DocType: 142; // Fisso a 142 per POD
  Tipo_Documento: 'POD'; // Fisso a 'POD'
  Origine_File: 'VLM'; // Sistema che carica la POD, fisso a 'VLM'
  FileArray: string; // Binario del file in formato base64
  FileName: string; // Nome del file, es: 'POD.pdf'
  DocName?: string; // Descrizione del file, opzionale
  DataOraFoto: string; // Data e ora di caricamento, formato: YYYY/MM/DD HH:mm:ss
  Account?: string; // Utente che ha caricato il file, opzionale
  AOO: 'ARCESE'; // Area Organizzativa, fisso a 'ARCESE'
  ID_Company: '110MI'; // Company ARCESE, fisso a '110MI'
  Stato: 'Valid'; // Stato iniziale, fisso a 'Valid'
  MITTENTI_DESTINATARI: string; // Concatenazione di carico/scarico
  TRANSPORT_ORDER_KEY: string; // TMS Key del Transport Order
  Sequenza_Doc: number; // Sequenziale per il caricamento POD
  file: FormData;
}
export interface UploadPODRequestBuffer {
  file: FormData; // Il file viene inviato come FormData
}

export interface UploadPODResponseBuffer {
  bufferIds: string[]; // La risposta contiene un array di bufferIds generati
}

export interface UploadPODResponse {
  Status: string; // Esito della chiamata, es: 'OK'
  DocNumber?: number; // Identificativo univoco del documento
  Message?: string; // Messaggio in caso di errore
}

export interface TripPODRequest {
  Cod_Viaggio: string;
  DocType: 142;
  Tipo_Documento: "POD";
  Origine_File: "VLM";
  AOO: "ARCESE";
}

export interface TripPODResponse {
  WORKFLOW: number | null;
  STATO: string | null;
  FORMATO: string | null;
  DOCNUMBER: number | null;
  CREATION_DATE: string | null; // ISO date string
  CLASSEDOC: string | null;
  AUTOREDESCRIPTION: string | null;
  ORIGINALE: string | null; // File name
  COMBO221_131: string | null;
  COMBO222_131: string | null;
  NUMERIC60_8: number | null;
  DOCNAME: string | null;
  TESTO223_131: string | null;
  TESTO265_131: string | null;
  TESTO227_131: string | null;
  TESTO246_136: string | null;
  DATA224_131: string | null; // ISO date string
  MULTI336_142: string | null;
  WFVERSIONSTATE: number | null;
  NOTE: string | null;
  REVISIONE: number;
}

export interface TripPODResponseEndirchedDocs {
  WORKFLOW: number | null;
  STATO: string | null;
  FORMATO: string | null;
  DOCNUMBER: number | null;
  CREATION_DATE: string | null; // ISO date string
  CLASSEDOC: string | null;
  AUTOREDESCRIPTION: string | null;
  ORIGINALE: string | null; // File name
  COMBO221_131: string | null;
  COMBO222_131: string | null;
  NUMERIC60_8: number | null;
  DOCNAME: string | null;
  TESTO223_131: string | null;
  TESTO265_131: string | null;
  TESTO227_131: string | null;
  TESTO246_136: string | null;
  DATA224_131: string | null; // ISO date string
  MULTI336_142: string | null;
  WFVERSIONSTATE: number | null;
  loadingPoint: string;
  unloadingPoint: string;
}
export interface TripPODApiResponse {
  columns: { id: string; label: string; position: number; columnType: string }[];
  data: any[][];
}

export interface MetadataResponse {
  DocNumber: number;
  Cod_Ordine: string;
  Cod_Viaggio: string;
  DocType: string;
  Tipo_Documento: string;
  Origine_File: string;
  FileName: string;
  DocName: string;
  DataOraFoto: string;
  Account: string;
  Stato: string;
  MessageStato?: string;
  MITTENTI_DESTINATARI: string;
  TRANSPORT_ORDER_KEY: string;
  Sequenza_Doc: number;
}
export interface PODFileResponse {
  DocNumber: number;
  FileArray: string; // Base64-encoded binary data
}


export interface PODFileRequest {
  DocNumber: number;
}

export interface TransportPDFRequest {
  tripId: number;
  legacyCode: string;
  language: string;
  contactId: string;
  accountId: string;
  company: string;
}

export interface VehicleData {
  licensePlate: string;
  firstRegistrationDate: string | null;
  environmentClass: string | null;
  fuelType: string | null;
  emissionsData: number;
  status: string;
  lastTraceabilityCheck: string;
}

export interface Vehicle {
  licensePlate: string;
  mainCategory: string | null;
  category: string | null;
  fuelType: string;
  environmentClass: string;
}

export interface Association {
  vehicleLicensePlate: string;
  vehicleSubType: string;
  vehicleType: string;
  dateFrom: string | null;
  dateTo: string | null;
  status: string;
  lastAssociationUpdate: string;
  id?: number;
}